import React, { Component } from "react";
import { FaPlusCircle } from 'react-icons/fa';

class Users extends Component {
    render() {
        return (
            <div className="uni-supervisors px-2 py-0 d-flex flex-wrap flex-lg-nowrap">
                <div className="new-supervisor px-3 py-5">
                    <form className="w-100 add-form">
                        <div className="add-form__add text-center p-4 w-100 my-4">
                            <FaPlusCircle className="mb-2" color="#fff" size="3rem" />
                            <h5>إضافة مستخدم للنظام</h5>
                        </div>
                        <div className="add-form__logo-input w-100 my-2">
                            <input type="file" className="d-none" id="uniLogo" />
                            <label className="w-100 d-flex " htmlFor="uniLogo">
                                <img className="ms-4" src="/icons/photo-camera-interface-symbol-for-button-blue.png" alt="camera" width="30" />
                                <h6 className="mb-0">صورة المستخدم</h6>
                            </label>
                        </div>
                        <div className="add-form__text-input w-100 my-2">
                            <input type="text" className="w-100 m-0 px-3 py-2" placeholder="اسم المستخدم" />
                        </div>
                        <div className="add-form__text-input w-100 my-2">
                            <input type="email" className="w-100 m-0 px-3 py-2" placeholder="البريد الإلكتروني" />
                        </div>
                        <div className="add-form__text-input w-100 my-2">
                            <input type="text" className="w-100 m-0 px-3 py-2" placeholder="رقم الهاتف" />
                        </div>
                        <div className="add-form__text-input w-100 my-2">
                            <input type="text" className="w-100 m-0 px-3 py-2" placeholder="كلمة المرور" />
                        </div>
                        <div className="add-form__text-input w-100 my-2">
                            <input type="text" className="w-100 m-0 px-3 py-2" placeholder="الدور الوظيفي" />
                        </div>
                        <button className="px-4 py-2 mx-2 my-4 blue-btn">حفظ</button>
                    </form>
                </div>
                <div className="supervisors py-5 px-1 px-lg-3 d-flex flex-wrap align-content-start w-100">
                    <div className="suber-card p-3 m-1 m-lg-3" style={{maxWidth: "300px"}}>
                        <div className="suber-card__header d-flex justify-content-between">
                            <img src="/images/temp/A91brptgb_zle5b0_ask.jpg" alt="supervisor" width="70" height="70" />
                            <div>
                                <button title="delete">
                                    <img className="m-1" src="/icons/trash.png" alt="delete" width="30" />
                                </button>
                            </div>
                        </div>
                        <div className="mt-1">
                            <h5>محمد سمير المصري</h5>
                            <h5>email@university.edu.eg</h5>
                            <h5>+962593496782</h5>
                        </div>
                    </div>
                    <div className="suber-card p-3 m-1 m-lg-3" style={{maxWidth: "300px"}}>
                        <div className="suber-card__header d-flex justify-content-between">
                            <img src="/images/temp/A91brptgb_zle5b0_ask.jpg" alt="supervisor" width="70" height="70" />
                            <div>
                                <button title="delete">
                                    <img className="m-1" src="/icons/trash.png" alt="delete" width="30" />
                                </button>
                            </div>
                        </div>
                        <div className="mt-1">
                            <h5>محمد سمير المصري</h5>
                            <h5>email@university.edu.eg</h5>
                            <h5>+962593496782</h5>
                        </div>
                    </div>
                    <div className="suber-card p-3 m-1 m-lg-3" style={{maxWidth: "300px"}}>
                        <div className="suber-card__header d-flex justify-content-between">
                            <img src="/images/temp/A91brptgb_zle5b0_ask.jpg" alt="supervisor" width="70" height="70" />
                            <div>
                                <button title="delete">
                                    <img className="m-1" src="/icons/trash.png" alt="delete" width="30" />
                                </button>
                            </div>
                        </div>
                        <div className="mt-1">
                            <h5>محمد سمير المصري</h5>
                            <h5>email@university.edu.eg</h5>
                            <h5>+962593496782</h5>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Users;